import React from "react";
import { Link, useLocation } from "react-router-dom";
import HorizontalRuleIcon from "@mui/icons-material/HorizontalRule";

const Breadcrumb = () => {
  const location = useLocation();

  return (
    <>
      <div className="d-flex bread-crumb align-items-center ">
        <Link
          style={{ textDecoration: "none", color: "#fff" }}
          to="/reporting/dashboard"
          className={`px-1 rounded   ${
            location.pathname.includes("/reporting/dashboard")
              ? " active  "
              : " "
          }`}
        >
          <span className="text-truncate menu-item">Dashboard</span>
        </Link>
        <HorizontalRuleIcon className="rotated" />
        <Link
          style={{ textDecoration: "none", color: "#fff" }}
          to="/reporting/report"
          className={`px-1 rounded   ${
            location.pathname.includes("/reporting/report") ? " active  " : " "
          }`}
        >
          <span className="text-truncate menu-item">Report</span>
        </Link>
      </div>
    </>
  );
};

export default Breadcrumb;
